import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Translate, Check } from "@phosphor-icons/react";
import { useI18n, LANGS } from "../lib/i18n";

export default function LanguagePicker() {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(() => {
    function onClick(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);
  return (
    <div className="relative" ref={ref}>
      <button data-testid="language-picker" onClick={() => setOpen((v) => !v)}
        title="Language"
        className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.05] text-white/85 transition hover:text-white">
        <Translate size={18} weight="fill" className="text-neon-cyan" />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -8, scale: 0.98 }}
            transition={{ duration: 0.16 }}
            data-testid="language-menu"
            className="absolute right-0 top-12 z-50 w-44 overflow-hidden rounded-2xl border border-white/10 bg-ink-900/95 backdrop-blur-xl shadow-[0_20px_60px_rgba(0,0,0,0.6)]">
            {LANGS.map((l) => (
              <button key={l.code} data-testid={`lang-${l.code}`} onClick={() => { setLang(l.code); setOpen(false); }}
                className={`flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left text-[13px] transition hover:bg-white/[0.06] ${lang === l.code ? "text-neon-cyan" : "text-white"}`}>
                <span>{l.label}</span>
                {lang === l.code && <Check size={14} weight="bold" />}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
